// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"f79927e2","359":"7e8630cc","505":"f77d26d5","639":"18a66d7a","718":"0187d8a1","931":"74769af6"}[chunkId] + ".css";
};